import { Row, useModal } from "@commonlibs";
import EditIcon from "ui/common/icons/EditIcon";
import EyeIcon from "ui/common/icons/EyeIcon";
import { spacing } from "ui/config/theme/spacing/spacing";
import createTyCModal from "./Modal";
import { UpdateTermsAndPrivacyName } from "./UpdateTermsAndPrivacyModal.types";
import useViewTermsPrivacy from "features/terms/hooks/useViewTermsPrivacy";
import useUserState from "ui/adapter/state/useUserState";
import { RoleType } from "common/models/role/Role";

export interface ViewAndUpdateTyCIconsProps {
    title: string;
    fileName: UpdateTermsAndPrivacyName;
    fileType: string;
}

export default function ViewAndUpdateTyCIcons({ title, fileName, fileType }: ViewAndUpdateTyCIconsProps) {
    const { showModal } = useModal();
    const TyCModal = createTyCModal(title, fileName);
    const { selectedRole } = useUserState();

    const { mutate: view } = useViewTermsPrivacy({
        onSuccess: (data) => {
            window.open(data as string, "_blank", "noopener,noreferrer");
        },
    });

    const isOwnerOrManager =
        selectedRole?.roleType === RoleType.ORGANIZATION_OWNER || selectedRole?.roleType === RoleType.OPERATION_MANAGER;

    return (
        <Row justifyContent="flex-start" gap={spacing["4"]}>
            <EyeIcon css={{ cursor: "pointer" }} fontSize={20} onClick={() => view(fileType)} />
            {isOwnerOrManager && <EditIcon css={{ cursor: "pointer" }} fontSize={20} onClick={() => showModal(TyCModal)} />}
        </Row>
    );
}
